import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDashboardMiddle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconDashboardMiddle"><Path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.1108 21.8189 14.1793 21.4846 15.1776C21.3539 15.0668 21.1847 15 21 15H12.75V8.75C12.75 8.33579 12.4142 8 12 8C11.5858 8 11.25 8.33579 11.25 8.75V15H3C2.81526 15 2.64612 15.0668 2.51541 15.1776C2.18111 14.1793 2 13.1108 2 12Z" fill="currentColor"/><Path d="M3.07031 16.5C4.71713 19.7626 8.09879 22 12.003 22C15.9073 22 19.2889 19.7626 20.9357 16.5H3.07031Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDashboardMiddle;
